import { getAppEnvironment } from './getAppEnvironment'

export const getIsAppTestingEnvironment = () => {
  const environment = getAppEnvironment()

  return ['development', 'staging'].includes(environment)
}
